import React from 'react';
import CloudExecutiveDashboard from './CloudExecutiveDashboard';

const GCPDashboard: React.FC = () => {
  return <CloudExecutiveDashboard provider="gcp" />;
};

export default GCPDashboard;
